import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import BpoSection from './components/BpoSection';
import StrengthsSection from './components/StrengthsSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <BpoSection />
      <StrengthsSection />
      <CtaSection />
      <Footer />
    </main>
  );
}